import { IWyshAllocationHistory } from "config/types";
import { getAllWyshAllocationHistories } from "store/actions/allocationHistory";
import { logout } from "store/actions/authentication";

import { createReducer } from "@reduxjs/toolkit";

const defaultState: IWyshAllocationHistory[] = [];

const allocationHistory = createReducer(defaultState, builder => {
  builder
    .addCase(getAllWyshAllocationHistories.fulfilled, (state, action) => {
      return action.payload as IWyshAllocationHistory[];
    })
    .addCase(logout, () => defaultState);
});

export default allocationHistory;
